import { createContext } from 'react';

export const GridContext = createContext({});
